import { render, staticRenderFns } from "./AdminCertificationDetail.vue?vue&type=template&id=5322ef2a&"
import script from "./AdminCertificationDetail.vue?vue&type=script&lang=js&"
export * from "./AdminCertificationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports